module.exports = __webpack_public_path__ + "static/media/3playerRoomsPlayed_250000_500000.8f96aa6f.png";